export const KsaHomeDataArabic = {
  ksaBanner: [
    {
      id: 1,
      backgroundImage: "/images/countries/riyadh/banner-1.avif",
      title: "أفضل شركة تطوير تم تكريمها من قبل",
      awardLogo: "/images/payoneer-circle.png",
      awardName: "بايونير",
      heading: [
        { text: "محفزك للحلول التوليدية لـ", isSpan: false },
        { text: " الذكاء الاصطناعي", isSpan: true },
        { text: " و", isSpan: false },
        { text: " التجارب التحولية", isSpan: true },
      ],
      subHeading:
        "حلول قائمة على النتائج وخدمات الذكاء الاصطناعي التوليدي للشركات الناشئة، والشركات الصغيرة والمتوسطة، والمؤسسات التي تسعى لأتمتة سير العمل.",
      buttonText: "ابنِ إرثك",
      buttonLink: "/contact-us",
    },
    {
      id: 2,
      backgroundImage: "/images/countries/riyadh/banner-2.avif",
      title: "أفضل شركة تطوير تم تكريمها من قبل",
      awardLogo: "/images/payoneer-circle.png",
      awardName: "بايونير",
      heading: [
        { text: "تمكين الابتكار باستخدام ", isSpan: false },
        { text: "البلوكشين", isSpan: true },
        { text: " ", isSpan: false },
        { text: "الخدمات", isSpan: true },
      ],
      subHeading:
        "استفد من خدمات البلوكشين القوية لدينا المصممة للشركات الناشئة، والشركات الصغيرة والمتوسطة، والمؤسسات. نقدم حلولًا آمنة وقابلة للتوسع ومبتكرة لمساعدتك في تحقيق أقصى استفادة من استثماراتك في تكنولوجيا المعلومات ودفع نمو الأعمال.",
      buttonText: "ابنِ إرثك",
      buttonLink: "/contact-us",
    },
    {
      id: 3,
      backgroundImage: "/images/countries/riyadh/banner-3.avif",
      title: "شركة رائدة في تطوير تطبيقات الويب معتمدة من قبل",
      awardLogo: "/images/payoneer-circle.png",
      awardName: "كلوتش",
      heading: [
        { text: "تمكين الأعمال من خلال ", isSpan: false },
        { text: "حلول الأمن السيبراني", isSpan: true },
        // { text: " و", isSpan: false },
        // { text: " تجارب مستخدم سلسة", isSpan: true },
      ],
      subHeading:
        "خدمات تطوير تطبيقات الويب من الدرجة الأولى المصممة خصيصًا للشركات الناشئة والشركات الصغيرة والمتوسطة والمؤسسات—لدفع التحول الرقمي وتعزيز التفاعل مع المستخدمين.",
      buttonText: "ابدأ مشروعك",
      buttonLink: "/contact-us",
    },
    {
      id: 4,
      backgroundImage: "/images/countries/riyadh/banner-4.avif",
      title:
        "شركة تطوير تطبيقات الهواتف المحمولة الحائزة على الجوائز والمعتمدة من",
      awardLogo: "/images/payoneer-circle.png",
      awardName: "كلوتش",
      heading: [
        { text: "تحويل الأفكار إلى ", isSpan: false },
        { text: "التطوير المخصص", isSpan: true },
        { text: " و", isSpan: false },
        { text: " تجارب مستخدم استثنائية", isSpan: true },
      ],
      subHeading:
        "خدمات تطوير تطبيقات الهواتف المحمولة للمؤسسات والشركات الناشئة والشركات الصغيرة والمتوسطة—مقدمة لك حلول متقدمة لتمكين أعمالك أثناء التنقل.",
      buttonText: "أطلق تطبيقك",
      buttonLink: "/contact-us",
    },
  ],
  sectionsButton: [
    { id: 1, heading: "الذكاء الاصطناعي" },
    { id: 2, heading: "خدمات البلوكشين" },
    { id: 3, heading: "تطوير تطبيقات الويب" },
    { id: 4, heading: "تطوير تطبيقات الهواتف المحمولة" },
  ],
  ksaScrollerData: [
    { text: "التقدير", link: "testimonial-section" },
    { text: "وظفنا", link: "hire-us" },
    { text: "لماذا نحن؟", link: "why-us" },
    { text: "تقنياتنا", link: "our-stacks" },
    { text: "خدمات تكنولوجيا المعلومات", link: "it-services" },
    { text: "النماذج", link: "engagment-models" },
    { text: "الصناعات", link: "pioner-change-box" },
    { text: "فريقنا الأساسي", link: "our-team" },
    { text: "الرؤى", link: "trends" },
    { text: "المواقع", link: "our-locations" },
  ],
  hireForUs: {
    slides: [
      {
        id: 1,
        icon: "/images/icon1.svg",
        heading: "تطوير الذكاء الاصطناعي",
        text: "نساعدك في الاستفادة من تقنيات الذكاء الاصطناعي المتقدمة مثل نماذج اللغة الكبيرة (LLMs)، والدردشات الآلية، ومعالجة اللغة الطبيعية (NLP) لأتمتة العمليات واتخاذ قرارات مدفوعة بالبيانات التي تتناسب مع احتياجات عملك.",
        btnLink: "contact-us",
      },
      {
        id: 5,
        icon: "/images/dashboard.png",
        heading: "تطوير البلوكشين",
        text: "استفد من حلول البلوكشين الآمنة والشفافة لتعزيز عمليات عملك، وزيادة الأمان، وتعزيز الثقة.",
        btnLink: "contact-us",
      },
      {
        id: 12,
        icon: "/images/high-values-icons/robust-architecture.svg",
        heading: "الأمن السيبراني",
        text: "حماية أصولك الرقمية من خلال حلول أمنية شاملة ضد التهديدات المتطورة.",
        btnLink: "contact-us",
      },
      {
        id: 3,
        icon: "/images/machine-learning.png",
        heading: "تطوير البرمجيات المخصصة",
        text: "هل تحتاج إلى حلول مخصصة؟ يقوم تطوير البرمجيات المخصصة لدينا بتحويل رؤيتك إلى واقع، مع تحسين الكفاءة والابتكار.",
        btnLink: "contact-us",
      },
      {
        id: 4,
        icon: "/images/icon3.svg",
        heading: "تحليل البيانات",
        text: "اكتشف قوة البيانات من خلال تحليلات مدفوعة بالذكاء الاصطناعي، ورؤى الأعمال (BI)، والنماذج التنبؤية لتعزيز اتخاذ القرارات المدفوعة بالبيانات.",
        btnLink: "contact-us",
      },
      {
        id: 7,
        icon: "/images/cloud.png",
        heading: "حلول السحابة",
        text: "عزز بنيتك التحتية السحابية مع خدمات ديف أوبس الخبراء على AWS وGCP وAzure—مما يضمن التوسع والأمان والكفاءة القصوى.",
        btnLink: "contact-us",
      },
      {
        id: 8,
        icon: "/images/web-programming.png",
        heading: "تطوير تطبيقات الويب",
        text: "قوّي حضورك الرقمي مع تطبيقات ويب قابلة للتوسع وعالية الأداء مصممة من أجل تجربة مستخدم سلسة ونمو الأعمال.",
        btnLink: "contact-us",
      },
      {
        id: 9,
        icon: "/images/mobile-development.png",
        heading: "تطوير تطبيقات الهواتف المحمولة",
        text: "حوّل الأفكار إلى تطبيقات موبايل قوية وسريعة باستخدام حلول أصلية، هجينة، ومتعددة المنصات لأجهزة iOS وAndroid.",
        btnLink: "contact-us",
      },
      {
        id: 6,
        icon: "/images/dekstop-icon.svg",
        heading: "تطوير تطبيقات سطح المكتب",
        text: "قم بتحسين الإنتاجية مع تطبيقات سطح مكتب مخصصة وآمنة وعالية الأداء مصممة خصيصًا لاحتياجات عملك الفريدة.",
        btnLink: "contact-us",
      },
      {
        id: 10,
        icon: "/images/software-testing.png",
        heading: "اختبار البرمجيات وضمان الجودة",
        text: "ضمان البرمجيات الخالية من الأخطاء من خلال خدمات QA الشاملة، واختبارات يدوية، وحلول مؤتمتة لضمان أداء سلس.",
        btnLink: "contact-us",
      },
      {
        id: 11,
        icon: "/images/video-marketing.png",
        heading: "التسويق الرقمي والنمو",
        text: "عزّز وجود علامتك التجارية على الإنترنت مع استراتيجيات التسويق الرقمي المدفوعة بالبيانات لزيادة التفاعل وبناء علاقات عملاء طويلة الأمد.",
        btnLink: "contact-us",
      },
    ],
    heading: "استعن بنا للحصول على خدمات تقنية شاملة تحقق النتائج",
    contentArray: [
      "سواء كنت بحاجة إلى برمجيات مخصصة، أو استشارات تقنية استراتيجية، أو تقنيات البلوك تشين المتطورة، أو الذكاء الاصطناعي المتقدم، أو أمن سيبراني قوي هنا في الولايات المتحدة، فنحن نوفر لك كل ذلك. يعمل فريقنا وفق ممارسات أجايل ومبدأ الأمن الصفري، لتضمن الأداء العالي، وقابلية التوسع، وراحة البال في كل مرحلة. نحن نقدم نتائج عالية الجودة تُحدث فرقاً حقيقياً في عملك.",
    ],

    iamLookingForButton: "أبحث عن",
    sidebar: {
      heading: "السعر الابتدائي الذي يناسب ميزانيتك/ خبرة عالية وخطط اقتصادية",
      subHeading: "حلول ذات تأثير عالٍ بأسعار معقولة/ حلول مميزة بأسعار ميسرة",
      paragraphOne:
        "لا يتعين أن يكلفك توسيع عملك مع تطوير البرمجيات المتميز، والاستشارات، والعلامات التجارية الرقمية الكثير من المال. نحن نقدم حلولاً مبتكرة مصممة خصيصاً لاحتياجاتك، مما يضمن أداءً سلساً وأماناً وابتكاراً، كل ذلك بأسعار معقولة.",
      paragraphTwo:
        "ابتداءً من 24 دولاراً في الساعة فقط، يضمن فريقنا الخبراء تقديم خدمات عالية الجودة تعزز الكفاءة والنمو. سواء كنت تطلق منتجاً جديداً، أو تحسين عملياتك، أو تقوية حضورك على الإنترنت، فإننا نقدم نتائج قابلة للقياس تعظم استثمارك.",
      letsBuildButton: "لنقم ببناء شيء عظيم",
    },
  },
  whyUs: {
    "greenHeading": "لماذا نحن",
    "heading": "لخدمات تطوير البرمجيات والاستشارات؟",
    "description": "Bitsclan ليست شركة تكنولوجيا عادية. نحن شركاؤك التقنيون الكاملون. نتحمل مسؤولية المشروع ونسلمه حتى خط النهاية.",
    "statsData": [
      {
        "number": "2017",
        "title": "نقدم التميز منذ عام"
      },
      {
        "number": "+120",
        "title": "مشروع ناجح تم تسليمه"
      },
      {
        "number": "+200",
        "title": "محترف مرتبط"
      },
      {
        "number": "+20",
        "title": "حلول عبر مختلف الصناعات"
      }
    ],
    "cta": {
      "text": "اتصل بنا",
      "link": "/contact-us"
    }
  },
  servicesInsights: {
    heading: "وظفنا للحصول على خدمات تقنية متكاملة تحقق النتائج",
    description:
      "سواء كنت تحتاج إلى برمجيات مخصصة، أو استشارات تقنية استراتيجية، أو تقنيات بلوكتشين حديثة، أو ذكاء اصطناعي متقدم، أو أمن سيبراني قوي هنا في الولايات المتحدة، فنحن نوفر لك كل ذلك.",
    topBox: [
      {
        id: 8,
        title: "خدمات بلوكتشين",
        description:
          "نقدم خدمات بلوكتشين مع حلول قائمة على السحابة لتحقيق تكامل أفضل، ووظائف سلسة، وبيئة آمنة.",
        linkText: "اعرف المزيد",
        linkURL: "blockchain-development-services",
        bgImg: "/images/enterprise-services/block-chain-services.avif",
        icon: "/images/home-page-icons/Blockchain-Services.svg",
        link: "/blockchain-development-services",
      },
      {
        id: 3,
        title: "خدمات الذكاء الاصطناعي",
        description:
          "في Bitsclan، تم تصميم حلولنا المعتمدة على الذكاء الاصطناعي لتلبية احتياجاتك الرقمية بسلاسة مع الحفاظ على أعلى معايير الأخلاق والكفاءة.",
        linkText: "اعرف المزيد",
        linkURL: "artificial-intelligence-development-services",
        bgImg: "/images/enterprise-services/ai-services.avif",
        icon: "/images/home-page-icons/AI-Services.svg",
        link: "/ai-ml-development-services",
      },
      {
        id: 4,
        title: "الأمن السيبراني",
        description:
          "حماية أصولك الرقمية بحلول أمنية شاملة ضد التهديدات المتطورة.",
        linkText: "اعرف المزيد",
        linkURL: "cyber-security-services",
        bgImg: "/images/enterprise-services/cyber-security.avif",
        icon: "/images/home-page-icons/Cyber-Security.svg",
        link: "/cyber-security-services",
      },
      {
        id: 2,
        title: "خدمات DevOps",
        description:
          "تبسيط عمليات التطوير والتشغيل لتقديم أسرع وتعاون معزز.",
        linkText: "اعرف المزيد",
        linkURL: "dev-ops-services",
        bgImg: "/images/enterprise-services/devops-services.avif",
        icon: "/images/home-page-icons/DevOps-Services.svg",
        link: "/dev-ops-services",
      },
      {
        id: 7,
        title: "تحليل البيانات",
        description:
          "تحويل البيانات إلى رؤى قابلة للتنفيذ لدفع عملية اتخاذ القرارات المستنيرة والنمو.",
        linkText: "اعرف المزيد",
        linkURL: "data-analytics-services",
        bgImg: "/images/enterprise-services/data-and-analytics.avif",
        icon: "/images/home-page-icons/Data-Analytics.svg",
        link: "/data-analytics-services",
      },
      {
        id: 5,
        title: "خدمات ضمان الجودة",
        description:
          "ضمان جودة عالية من خلال الاختبارات الصارمة والتحقق لأداء لا تشوبه شائبة.",
        linkText: "اعرف المزيد",
        linkURL: "quality-assurance-services",
        bgImg: "/images/enterprise-services/quality-assurance.avif",
        icon: "/images/home-page-icons/Quality-Assurance-Services.svg",
        link: "/quality-assurance-services",
      },
      {
        id: 1,
        title: "تطوير تطبيقات الموبايل",
        description:
          "من خلال خدماتنا لتطوير تطبيقات الموبايل المدمجة بالذكاء الاصطناعي، نقدم حلولًا مستقبلية لأنظمة iOS، android، و Windows.",
        linkText: "اعرف المزيد",
        linkURL: "mobile-app-development-services",
        bgImg: "/images/enterprise-services/mobile-app-development.avif",
        icon: "/images/home-page-icons/Mobile-app-development.svg",
        link: "/mobile-app-development-services",
      },
      {
        id: 9,
        title: "تطوير البرمجيات المخصصة",
        description:
          "نقدم خدمات تطوير برمجيات مخصصة لشركتك توفر قابلية التوسع والخصوصية.",
        linkText: "اعرف المزيد",
        linkURL: "custom-software-development-services",
        bgImg: "/images/enterprise-services/software-development.avif",
        icon: "/images/home-page-icons/Custom-Software-Development.svg",
        link: "/custom-software-development-services",
      },
    ],
    cta: {
      text: "لننمو معًا",
      link: "/contact-us"
    }
  },
  pioneeringChange: {
    heading: "ريادة التغيير",
    greenHeading: "عبر الصناعات",
    description:
      "قيادة الابتكار وتحويل القطاعات من خلال الحلول والرؤى المتطورة.",
    learnMoreLeft: "تعرف أكثر عن",
    learnMoreRight: "صناعتنا",
  },
  ourTeam: {
    heading: "فريقنا الأساسي",
    subHeading:
      "اكتشف رؤى الخبراء حول أحدث التطورات في الصناعة، والاتجاهات، والتقنيات الناشئة التي تشكل المستقبل.",
    team: [
      {
        name: "أويس سرور",
        location: "الولايات المتحدة الأمريكية",
        designation: "الرئيس التنفيذي",
        image: "/images/life-at-bitsclan/awais.avif",
      },
      {
        name: "حيدر جاويد",
        location: "الولايات المتحدة الأمريكية",
        designation: "الرئيس التنفيذي للتقنية",
        image: "/images/life-at-bitsclan/haider.avif",
      },
      {
        name: "كيفين هيوستن",
        location: "الولايات المتحدة الأمريكية",
        designation: "مدير الاستشارات والشراكات",
        image: "/images/life-at-bitsclan/kevin.avif",
      },
      {
        name: "إيجور سيلفا",
        location: "كندا",
        designation: "مدير الاستشارات والشراكات",
        image: "/images/life-at-bitsclan/team-usa1.avif",
      },
      {
        name: "أندريا راي",
        location: "الولايات المتحدة الأمريكية",
        designation: "مدير نجاح العملاء",
        image: "/images/life-at-bitsclan/andreea.avif",
      },
      {
        name: "أومونيي أوافيسوبي",
        location: "الولايات المتحدة الأمريكية",
        designation: "مدير الاستشارات والشراكات",
        image: "/images/life-at-bitsclan/omoniyi.avif",
      },
      {
        name: "شمس شمّاسي",
        location: "المملكة العربية السعودية",
        designation: "الشريك المدير",
        image: "/images/life-at-bitsclan/shams.avif",
      },
    ],
  },
  ourLocations: {
    heading: "مواقعنا",
    locations: [
      {
        title: "المكتب الرئيسي",
        location: "نيويورك",
        address: "2 بارك أفينيو الطابق 20، نيويورك، NY 10016",
        icon: "new-york.svg",
      },
      {
        title: "مكتب أوروبا",
        location: "السويد",
        address: "بيرغسغاردسجيردت 71، LGH 1101، 424 32 أنجيريد",
        icon: "Sweden.svg",
      },
      {
        title: "مكتب الخليج",
        location: "المملكة العربية السعودية",
        address:
          "المبنى 26/27، الطريق 120 A، صناعات الدعم، مدينة الجبيل الصناعية، المملكة العربية السعودية",
        icon: "Qatar.svg",
      },
      {
        title: "مكتب أستراليا",
        location: "أستراليا",
        address: "ص.ب 1244، فيتزروي نورث، فيكتوريا، 3068",
        icon: "Australia.svg",
      },
    ],
  },
  tabsData: {
    tabs: [
      "الذكاء الاصطناعي",
      "الأمن السيبراني",
      "قاعدة البيانات",
      "العملات الرقمية",
      "الخلفية",
      "الواجهة الأمامية",
      "الموبايل",
      "الأطر",
      "السحابة",
      "ديف أوبس",
      "التجارة الإلكترونية",
      "المنصات",
    ],
    tabItems: [
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/genai1.svg",
        name: "CycleGAN",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/genai2.svg",
        name: "DeepArt",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/genai3.svg",
        name: "DeepDream",
      },
      { tab: "الذكاء الاصطناعي", icon: "/images/genai4.svg", name: "VQ-VAE" },
      { tab: "الذكاء الاصطناعي", icon: "/images/genai5.svg", name: "GPT-4" },
      { tab: "الذكاء الاصطناعي", icon: "/images/genai6.svg", name: "GPT-3" },
      { tab: "الذكاء الاصطناعي", icon: "/images/genai6.svg", name: "DALL-E" },
      { tab: "الذكاء الاصطناعي", icon: "/images/genai6.svg", name: "OpenAI GPT" },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/genai6.svg",
        name: "OpenAI DALL-E",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/module1.svg",
        name: "DeepMind Sonnet",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/module2.svg",
        name: "Facebook AI Research ",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/module3.svg",
        name: "Hugging Face",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/module4.svg",
        name: "NVIDIA StyleGAN",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/tech-icon.svg",
        name: "PyTorch",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/tech-icon2.svg",
        name: "Keras",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/tech-icon3.svg",
        name: "MXNet",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/tech-icon4.svg",
        name: "TensorFlow",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/tech-icon5.svg",
        name: "Caffe",
      },
      { tab: "الذكاء الاصطناعي", icon: "/images/natural1.svg", name: "RBM" },
      { tab: "الذكاء الاصطناعي", icon: "/images/natural2.svg", name: "DBN" },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/natural7.svg",
        name: "Transformers",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/natural4.svg",
        name: "Autoencoders",
      },
      { tab: "الذكاء الاصطناعي", icon: "/images/natural5.svg", name: "DRLN" },
      { tab: "الذكاء الاصطناعي", icon: "/images/natural6.svg", name: "GAN" },
      { tab: "الذكاء الاصطناعي", icon: "/images/tech-icon.svg", name: "PyTorch" },
      { tab: "الذكاء الاصطناعي", icon: "/images/tech-icon2.svg", name: "Keras" },
      { tab: "الذكاء الاصطناعي", icon: "/images/tech-icon3.svg", name: "MXNet" },
      { tab: "الذكاء الاصطناعي", icon: "/images/libraries1.svg", name: "FastAI" },
      { tab: "الذكاء الاصطناعي", icon: "/images/libraries2.svg", name: "TensorFlow" },
      { tab: "الذكاء الاصطناعي", icon: "/images/libraries3.svg", name: "Theano" },
      { tab: "الذكاء الاصطناعي", icon: "/images/libraries4.svg", name: "Scikit-learn" },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/calsification.svg",
        name: "AlexNet",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/calsification2.svg",
        name: "EfficientNet",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/calsification3.svg",
        name: "Xception",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/calsification4.svg",
        name: "DenseNet",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/calsification5.svg",
        name: "Inception",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/calsification6.svg",
        name: "ResNet",
      },
      {
        tab: "الذكاء الاصطناعي",
        icon: "/images/calsification7.svg",
        name: "VGGNet",
      },
      // CYBER SECURITY ICONS
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/burp-suite.png",
        name: "Brup Suite",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/check-point.png",
        name: "Check Point",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/cisco-secures.png",
        name: "Ciso Secures",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/crowd-strike.png",
        name: "Crowd Strike",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/dark-trace.png",
        name: "Dark Trace",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/fortinet.png",
        name: "Fortinet",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/kali.png",
        name: "Kali",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/metasploit.png",
        name: "Metasploit",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/nessus.png",
        name: "Nessus",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/qradar-logo.png",
        name: "IBM Radar",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/qualys.png",
        name: "Qualys",
      },

      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/snort.png",
        name: "Snort",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/splunk.png",
        name: "Splunk",
      },
      {
        tab: "الأمن السيبراني",
        icon: "/images/tech-stack-icons/wire-shark.png",
        name: "Wire Shark",
      },
      // Blockchain Platforms
      {
        tab: "العملات الرقمية",
        icon: "/images/tech-stack-icons/ethereum.png",
        name: "Ethereum",
      },
      {
        tab: "العملات الرقمية",
        icon: "/images/tech-stack-icons/stellar.png",
        name: "Stellar",
      },
      {
        tab: "العملات الرقمية",
        icon: "/images/tech-stack-icons/Ripple.png",
        name: "Ripple",
      },

      // Enterprise Solutions
      {
        tab: "العملات الرقمية",
        icon: "/images/tech-stack-icons/Hyperledger.png",
        name: "HyperLedger",
      },
      {
        tab: "العملات الرقمية",
        icon: "/images/tech-stack-icons/microsoft-icon.png",
        name: "Azure Blockchain",
      },
      {
        tab: "العملات الرقمية",
        icon: "/images/tech-stack-icons/download-3.png",
        name: "Azure Service Fabric",
      },

      // Consensus Mechanisms
      {
        tab: "العملات الرقمية",
        icon: "/images/tech-stack-icons/tendermint-logo-black.png",
        name: "Tendermint",
      },

      // Storage Solutions
      {
        tab: "العملات الرقمية",
        icon: "/images/tech-stack-icons/IPFS_logo.png",
        name: "IPFS",
      },
      {
        tab: "العملات الرقمية",
        icon: "/images/tech-stack-icons/Bigchaindb.png",
        name: "BigChainDB",
      },
      {
        tab: "الواجهة الأمامية",
        icon: "/images/iconone.png",
        name: "Angular JS",
      },
      {
        tab: "الواجهة الأمامية",
        icon: "/images/icontwo.png",
        name: "JavaScript",
      },
      {
        tab: "الواجهة الأمامية",
        icon: "/images/iconthree.png",
        name: "React JS",
      },
      { tab: "الواجهة الأمامية", icon: "/images/icon4.png", name: "Vue JS" },
      { tab: "الواجهة الأمامية", icon: "/images/icon5.png", name: "Tez JS" },
      { tab: "الواجهة الأمامية", icon: "/images/icon6.png", name: "CSS3" },
      { tab: "الواجهة الأمامية", icon: "/images/icon7.png", name: "HTML5" },
      { tab: "الخلفية", icon: "/images/database1.png", name: ".Net" },
      { tab: "الخلفية", icon: "/images/database2.png", name: "Nest Js" },
      { tab: "الخلفية", icon: "/images/database3.png", name: "Meteor JS" },
      { tab: "الخلفية", icon: "/images/database4.png", name: "Fastify" },
      { tab: "الخلفية", icon: "/images/database5.png", name: "Express JS" },
      { tab: "الخلفية", icon: "/images/database6.png", name: "Python" },
      { tab: "الخلفية", icon: "/images/database7.png", name: "Java" },
      { tab: "الخلفية", icon: "/images/database8.png", name: "PHP" },
      { tab: "الخلفية", icon: "/images/database9.png", name: "Node Js" },
      { tab: "الموبايل", icon: "/images/mobile1.png", name: "Android" },
      { tab: "الموبايل", icon: "/images/mobile2.png", name: "IOS" },
      { tab: "الموبايل", icon: "/images/mobile3.png", name: "Swift" },
      { tab: "الموبايل", icon: "/images/mobile4.png", name: "Flutter" },
      { tab: "الموبايل", icon: "/images/mobile5.png", name: "Xamarin" },
      { tab: "الموبايل", icon: "/images/mobile6.png", name: "React Native" },
      { tab: "قاعدة البيانات", icon: "/images/db1.png", name: "Firebase" },
      { tab: "قاعدة البيانات", icon: "/images/db2.png", name: "Oracle " },
      { tab: "قاعدة البيانات", icon: "/images/db3.png", name: "MongoDB" },
      {
        tab: "قاعدة البيانات",
        icon: "/images/tech-stack-icons/postgres.svg",
        name: "PostgreSQL",
      },
      { tab: "قاعدة البيانات", icon: "/images/db5.png", name: "MySQL" },
      { tab: "قاعدة البيانات", icon: "/images/db6.png", name: "SQL Server" },
      { tab: "قاعدة البيانات", icon: "/images/db7.png", name: "SQLite" },
      { tab: "قاعدة البيانات", icon: "/images/db8.png", name: "DynamoDB" },
      { tab: "الأطر", icon: "/images/framework6.png", name: "Django" },
      {
        tab: "الأطر",
        icon: "/images/framework2.png",
        name: "CodeIgniter",
      },
      { tab: "الأطر", icon: "/images/framework3.png", name: "Laravel" },
      { tab: "الأطر", icon: "/images/framework1.png", name: "MEAN" },
      { tab: "الأطر", icon: "/images/framework4.png", name: "Rxweb.io" },
      { tab: "الأطر", icon: "/images/framework5.png", name: "CakePHP" },
      { tab: "السحابة", icon: "/images/cloud1.png", name: "Google Cloud" },
      { tab: "السحابة", icon: "/images/cloud2.png", name: "Azure" },
      { tab: "السحابة", icon: "/images/cloud3.png", name: "AWS" },
      {
        tab: "السحابة",
        icon: "/images/DigitalOcean.png",
        name: "Digital Ocean",
      },
      { tab: "ديف أوبس", icon: "/images/devops1.png", name: "Gradle" },
      { tab: "ديف أوبس", icon: "/images/devops2.png", name: "Kubernetes" },
      { tab: "ديف أوبس", icon: "/images/devops3.png", name: "Docker" },
      { tab: "ديف أوبس", icon: "/images/devops4.png", name: "Jenkins" },
      {
        tab: "ديف أوبس",
        icon: "/images/openshift-svgrepo-com.svg",
        name: "Open Shift",
      },
      {
        tab: "ديف أوبس",
        icon: "/images/packer-svgrepo-com.svg",
        name: "Packer",
      },
      {
        tab: "ديف أوبس",
        icon: "/images/ansible-svgrepo-com.svg",
        name: "Ansible",
      },
      {
        tab: "ديف أوبس",
        icon: "/images/saltstack-svgrepo-com.svg",
        name: "Salt Stack",
      },
      {
        tab: "التجارة الإلكترونية",
        icon: "/images/ecomres1.png",
        name: "NopCommerce",
      },
      {
        tab: "التجارة الإلكترونية",
        icon: "/images/ecomres2.png",
        name: "Kentico",
      },
      {
        tab: "التجارة الإلكترونية",
        icon: "/images/ecomres3.png",
        name: "Shopify",
      },
      {
        tab: "التجارة الإلكترونية",
        icon: "/images/ecomres4.png",
        name: "Magento",
      },
      {
        tab: "التجارة الإلكترونية",
        icon: "/images/ecomres5.png",
        name: "WooCommerce",
      },
      { tab: "المنصات", icon: "/images/platform1.png", name: "Servicenow " },
      { tab: "المنصات", icon: "/images/platform2.png", name: "Tableau" },
      {
        tab: "المنصات",
        icon: "/images/platform3.png",
        name: "MS Dynamics CRM",
      },
      { tab: "المنصات", icon: "/images/platform4.png", name: "Zoho" },
      { tab: "المنصات", icon: "/images/platform5.png", name: "Power BI" },
      { tab: "المنصات", icon: "/images/platform6.png", name: "Salesforce " },
    ],
    default: "الواجهة الأمامية",
    heading: "لا داعي للقلق! لدينا مجموعة التكنولوجيا التي تبحث عنها!",
    subHeading:
      "لدينا خبراء في جميع مجموعات التكنولوجيا الرئيسية والشائعة تقريبًا. فريقنا يتوسع بسرعة، ويغطي المزيد من لغات البرمجة والخبرات. يمكنك أن تكون واثقًا من أنك ستحصل على الخبراء الذين تحتاجهم عند العمل معنا.",
  },
  caseStudiesSection: {
    shortHeading: "دراسات الحالة الخاصة بنا",
    mainHeading: "موثوق بنا من قبل الشركات الرائدة في العالم",
    description: "حصلنا على جائزة أفضل شركة لتطوير البرمجيات للعام من بايونير في عام 2021. نحن نقدم نفس الخبرة، التفاني، الرؤية، والقناعة في كل خدمة نقدمها.",
    cta: {
      text: "عرض جميع دراسات الحالة",
      link: "/case-studies"
    }
  }
};
